/**
 * GraphQL fragments for Contract primitive (SLA/Service Level Agreement)
 *
 * Complete field coverage: 28 fields
 * Aligned with contract_model.rs GqlContract exposed fields
 */

import { gql } from '@apollo/client';

/**
 * Core Contract fields fragment - All 28 exposed fields
 */
export const CONTRACT_FIELDS = gql`
  fragment ContractFields on Contract {
    # Identity Fields (5)
    id
    tenantId
    slaName
    slug
    externalId
    entityType

    # Entity Reference Fields (2)
    entityId
    workflowInstanceId

    # Notification Fields (3)
    notificationActorIds
    notificationChannels
    notificationAtPercent

    # Runtime State Fields (5)
    startedAt
    currentStatus
    elapsedMinutes
    lastCheckedAt
    paused

    # Time Thresholds Fields (4)
    responseTimeMinutes
    resolutionTimeMinutes
    warningThresholdPercent
    escalateAfterMinutes

    # Escalation Fields (1)
    escalationChain

    # Metrics Fields (3)
    breachCount
    complianceRate
    lastBreachAt

    # Audit Fields (4)
    createdAt
    updatedAt
    createdBy
    metadata

    # Complex Object (1)
    compressedId
  }
`;

// Legacy alias for backwards compatibility
export const SLA_FIELDS = CONTRACT_FIELDS;

/**
 * Contract connection fragment for paginated queries
 */
export const CONTRACT_CONNECTION_FIELDS = gql`
  ${CONTRACT_FIELDS}
  fragment ContractConnectionFields on ContractConnection {
    items {
      ...ContractFields
    }
    total
    nextCursor
    hasMore
  }
`;

// Legacy alias
export const SLA_CONNECTION_FIELDS = CONTRACT_CONNECTION_FIELDS;

/**
 * Contract compliance report fragment for tenant-wide metrics
 */
export const CONTRACT_COMPLIANCE_REPORT_FIELDS = gql`
  fragment ContractComplianceReportFields on ContractComplianceReport {
    tenantId
    totalContracts
    activeCount
    warningCount
    breachedCount
    metCount
    overallComplianceRate
  }
`;

// Legacy alias
export const SLA_COMPLIANCE_REPORT_FIELDS = CONTRACT_COMPLIANCE_REPORT_FIELDS;
